import user from './auth'

export default {
    guest (to, from, next) {
        next(user.check() ? '/' : true)
    },

    auth (to, from, next) {
        next(user.check() ? true : {
            path: '/login',
            query: {
                redirect: 'requests'
            }
        })
    }
}